
















































































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import TuiTree from '@/components/display/TuiTree.vue';
import {i18nAllObject, i18nInObjectList} from '@/utils/i18n';
import {getStorageByName, readExcelFile, writeExcel} from '@/utils/excel';
import {changeDateFormat, getDownToday} from '@/utils/dateUtils';
import editor from '@/components/common/summernote/Index.vue';
import { uploadFile, toI18n, getCurrency, getLocalStorageMalls } from '@/utils/commonUtils';
import {ncpPopup, gridModelToExcel} from '@/utils/ncp';
import ItemTable from '@/components/common/ItemTable.vue';
import LayerPopup from '@/components/LayerPopup.vue';
import {
  Mall,
  ProductsSearchRequest,
  GetDisplayCategoriesTreeRequest,
  PutDisplayCategoriesSyncRequest,
  PutProductsCategoryMappingsRequest,
  GetProductsSearchForDisplayCategoryRequest,
  GetDisplayCategoriesExcelRequest
} from 'supporter';

const mallModule = namespace('mall');

import { namespace } from 'vuex-class';
import { PopupRequestData } from '@/types';
@Component({
  components: {TuiTree, editor, ItemTable, LayerPopup}
})
export default class DisplayCategory extends Vue {
  @mallModule.State('malls')
  private malls!: Mall[];
  private mallInfo: Mall[] = getLocalStorageMalls();
  private tree: any;
  private data: any;
  private theData: any[] = [];
  private selectNum: number = 1;
  private selectParentForm: any = {};
  private selectChildForm: any = {};
  private childShow: boolean = false;
  private type: string = 'configMenu';
  private wrapShow: boolean = false;
  private checked: string = 'N';
  private strLength: number = 0;
  private codeLength: number = 0;
  private showTooltipCategoryCode: boolean = false;
  private tooltipCategoryCode: PopupRequestData = {
    id: 'tooltipCategoryCode',
    width: 500,
    title: 'DISPLAY_CATEGORIES_DISPLAY_CATEGORY_CODE',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    hasVerticalScroll: true
  };
  private isCheckedCategoryCode = true;
  private isFile: boolean = true;
  private isEmpty: boolean = false;
  private editorContent: string = '';
  private isCategoryIconRemoved: boolean = false;
  private mallNo: number = this.initMallNo;
  private curSelectedIdx: number = 0;
  private hasEditSummernote: any;
  private gridData: any = [];
  private addProductList: any = '';
  private uploadFileNos: any[] = [];
  private styleLeft = 0;
  private get initMallNo() {
    return this.mallInfo[0].mallNo;
  }

  private tableOptions = {
    noBorder: true,
    pageSize: 100,
    onLoadSearch: false,
    haveExcelDownBtn: false,
    excelDownInfo: {
      fileName: 'display_category_products_',
      columns: {},
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };
  public excel = {
    columns: [
      {
        header: this.toI18n('TSHOPPING_MALL'), //쇼핑몰
        name: 'mallName'
      },
      {
        header: this.toI18n('TPRODUCT_NUMBER'), //상품번호
        name: 'productNo'
      },
      {
        header: this.toI18n('TPRODUCT_MANAGEMENT_CODE'), //상품관리코드
        name: 'productManagementCd'
      },
      {
        header: this.toI18n('TPRODUCT_NAME'), //상품명
        name: 'productName'
      },

      {
        header: this.toI18n('TBRAND'), //브랜드
        name: 'brandName'
      },
      {
        header: this.toI18n('TPARTNER'), //파트너사
        name: 'partnerName'
      },
      {
        header: this.toI18n('TMANAGER'), //담당자
        name: 'adminName'
      },
      {
        header: this.toI18n('TFEES'), //수수료
        name: 'commissionRate',
        formatter: ({row}: any): string => {
          if (row.saleMethodType === 'PURCHASE' || row.commission.type === 'PURCHASE_PRICE') {
            return '-';
          }

          return `${row.commission.rate}%`;
        }
      },
      {
        header: this.toI18n('TSUPPLY_PRICE'), //공급가
        name: 'supplyPrice',
        formatter: ({value, row}: any): string => {
          if (row.saleMethodType === 'PURCHASE') {
            return '-';
          }
          return getCurrency(value, this.USMallNos.includes(row.mallNo));
        }
      },
      {
        header: this.toI18n('TPURCHASE_PRICE'), //매입가
        name: 'purchasePrice',
        formatter: ({value, row}: any): string => {
          if (row.saleMethodType === 'CONSIGNMENT') {
            return '-';
          }
          return getCurrency(value, this.USMallNos.includes(row.mallNo));
        }
      },
      {
        header: this.toI18n('TAPPROVAL_STATUS'), //승인상태
        name: 'applyStatusType',
        formatter: ({row}: any): any => {
          let text = '';
          switch (row.applyStatusType) {
            case 'REGISTRATION_READY':
              text = this.toI18n('TWAITING_FOR_REGISTRATION'); //등록대기
              break;
            case 'APPROVAL_READY':
              text = this.toI18n('TWAITING_FOR_APPROVAL'); //승인대기
              break;
            case 'APPROVAL_REJECTION':
              text = this.toI18n('TREJECTION_OF_APPROVAL'); //승인거부
              break;
            case 'SALE_AGREEMENT_READY':
              text = this.toI18n('TWAITING_FOR_SALES_AGREEMENT'); //판매합의대기
              break;
            case 'SALE_AGREEMENT_REJECTION':
              text = this.toI18n('TREJECTION_OF_SALES_AGREEMENT'); //판매합의거부
              break;
            case 'AFTER_APPROVAL_READY':
              text = this.toI18n('TWAITING_FOR_APPROVAL_AFTER_MODIFICATION'); //수정 후 승인대기
              break;
            case 'AFTER_APPROVAL_REJECTION':
              text = this.toI18n('TREJECT_APPROVAL_AFTER_MODIFICATION'); //수정 후 승인거부
              break;
            default:
              return this.toI18n('TAPPROVAL_COMPLETED'); //승인완료
              break;
          }
          return text;
        }
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_EIGHT', //판매상태
        name: 'saleStatusType',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => {
          if (this.saleStatusList.filter((v) => v.value == data.value).length) {
            return this.saleStatusList.filter((v) => v.value == data.value)[0].label;
          }
          return '-';
        }
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_EIGHT2', //판매설정상태
        name: 'saleSettingStatusType',
        align: 'center',
        minWidth: 100,
        formatter: (data: any) => {
          if (this.saleSettingStatusTypes.filter((v) => v.value == data.value).length) {
            return this.saleSettingStatusTypes.filter((v) => v.value == data.value)[0].label;
          }
          return '-';
        }
      },
      {
        header: 'DISPLAY_CATEGORIES_DISPLAY_STATUS',
        name: 'frontDisplayable',
        formatter: ({value}: any): string => {
          const val = String(value);
          let text = '';
          switch (val) {
            case 'true':
              text = this.toI18n('TDISPLAY_POSSIBLE'); //전시가능
              break;
            case 'false':
              text = this.toI18n('TNO_EXHIBITION'); //전시안함
              break;
          }
          return text;
        }
      },
      {
        header: this.toI18n('TSALES_PERIOD'), //판매기간
        name: 'salePeriod',
        formatter: ({value}: any): string => {
          if (value && value.startDateTime && value.endDateTime) {
            return `${value.startDateTime} ~ ${value.endDateTime}`;
          } else {
            return '-';
          }
        }
      },
      {
        header: this.toI18n('TDISCOUNT_APPLICABLE_PRICE'), //할인적용가
        name: 'appliedImmediateDiscountPrice',
        formatter: ({value, row}: any): string => {
          const val = getCurrency(value, row.countryCd === 'US');
          if (parseInt(val, 10) <= 0) {
            return '0';
          }
          return val;
        }
      },

      {header: this.toI18n('TADDITIONAL_DISCOUNT'), name: 'additionalDiscountAmount'}, //추가할인

      {
        header: this.toI18n('TADDITIONAL_DISCOUNT_APPLICABLE'),
        name: 'appliedAdditionalDiscountPrice',
        formatter: ({value, row}: any): string => {
          const val = getCurrency(value, row.countryCd === 'US');
          if (parseInt(val, 10) <= 0) {
            return '0';
          }
          return val;
        }
      }, //추가할인적용가
      {header: '추가할인명', name: 'additionalDiscountName'}, //추가할인명
      {
        header: this.toI18n('TINVENTORY_QUANTITY'), //재고수량&(판매가능재고)
        name: 'stockCnt',
        formatter: ({row}: any): string => {
          if(row.productStock && row.productStock.totalCnt) {
            const val = row.productStock.totalCnt.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
            return val;
          } else {
            return '';
          }
        }
      },
      {
        header: this.toI18n('TAPPLY_PROMOTION'), //프로모션적용
        name: 'promotionYn',
        formatter: ({row}: any): string => {
          if (row.canPromotion) {
            return 'Y';
          }
          return 'N';
        }
      },
      {
        header: this.toI18n('TEXHIBITION_CATEGORY'), //전시카테고리
        name: 'displayCategoryNames'
      }
    ]
  };
  public beforeApprovalStatus = ['REGISTRATION_READY', 'APPROVAL_READY', 'APPROVAL_REJECTION', 'SALE_AGREEMENT_READY', 'SALE_AGREEMENT_REJECTION'];
  private applyStatusType = [
    {value: 'ALL', label: window.$t('DISPLAY_CATEGORIES_ALL')},
    {value: 'REGISTRATION_READY', label: window.$t('DISPLAY_CATEGORIES_REGISTRATION_READY')},
    {value: 'APPROVAL_READY', label: window.$t('DISPLAY_CATEGORIES_APPROVAL_READY')},
    {value: 'APPROVAL_REJECTION', label: window.$t('DISPLAY_CATEGORIES_APPROVAL_REJECTION')},
    {value: 'SALE_AGREEMENT_READY', label: window.$t('DISPLAY_CATEGORIES_SALE_AGREEMENT_READY')},
    {value: 'SALE_AGREEMENT_REJECTION', label: window.$t('DISPLAY_CATEGORIES_SALE_AGREEMENT_REJECTION')},
    {value: 'FINISHED', label: window.$t('DISPLAY_CATEGORIES_FINISHED')},
    {value: 'AFTER_APPROVAL_READY', label: window.$t('DISPLAY_CATEGORIES_AFTER_APPROVAL_READY')},
    {value: 'AFTER_APPROVAL_REJECTION', label: window.$t('DISPLAY_CATEGORIES_AFTER_APPROVAL_REJECTION')}
  ];
  private saleStatusList = [
    {value: 'PRE_APPROVAL_STATUS', label: '-'},
    {value: 'WAITING_SALE', label: window.$t('DISPLAY_CATEGORIES_WAITING_SALE')},
    {value: 'ON_SALE', label: window.$t('DISPLAY_CATEGORIES_ON_SALE')},
    {value: 'END_SALE', label: window.$t('DISPLAY_CATEGORIES_END_SALE')},
    {value: 'ON_PRE_SALE', label: window.$t('DISPLAY_CATEGORIES_ON_PRE_SALE')}
  ];
  private saleSettingStatusTypes = [
    {value: 'STOP_SELLING', label: window.$t('DISPLAY_CATEGORIES_STOP_SELLING')},
    {value: 'PROHIBITION_SALE', label: window.$t('DISPLAY_CATEGORIES_PROHIBITION_SALE')},
    {value: 'AVAILABLE_FOR_SALE', label: window.$t('DISPLAY_CATEGORIES_AVAILABLE_FOR_SALE')}
  ];

  private isChanged: boolean = false;
  private gridProps = {
    options: {
      pageOptions: {
        perPage: 1,
        page: 1,
        totalCount: 0
      },
      rowHeaders: ['checkbox'],
      minRowHeight: 27,
      rowHeight: 27,
      minBodyHeight: 190,
      bodyHeight: 480,
      columnOptions: {
        minWidth: 50,
        frozenCount: 9,
        resizable: true
      },
      heightResizable: true
    },
    columns: [
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_ONE',
        name: 'mallName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_TWO',
        name: 'productNo',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_THREE',
        align: 'center',
        minWidth: 100,
        name: 'productManagementCd'
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_FOUR',
        align: 'center',
        minWidth: 100,
        name: 'productName'
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_FIVE',
        align: 'center',
        minWidth: 100,
        name: 'brandName'
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_SIX',
        name: 'partnerName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_SEVEN',
        name: 'applyStatusType',
        align: 'center',
        minWidth: 100,
        formatter: (data: any) => {
          if (this.applyStatusType.filter((v) => v.value == data.value).length) {
            return this.applyStatusType.filter((v) => v.value == data.value)[0].label;
          }
          return '-';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_EIGHT',
        name: 'saleStatusType',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => {
          if (this.saleStatusList.filter((v) => v.value == data.value).length) {
            return this.saleStatusList.filter((v) => v.value == data.value)[0].label;
          }
          return '-';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_EIGHT2',
        name: 'saleSettingStatusType',
        align: 'center',
        minWidth: 100,
        formatter: (data: any) => {
          if (this.saleSettingStatusTypes.filter((v) => v.value == data.value).length) {
            return this.saleSettingStatusTypes.filter((v) => v.value == data.value)[0].label;
          }
          return '-';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'DISPLAY_CATEGORIES_TABLE_HEADER_NINE',
        name: 'delete',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => {
          return `<span class="removeBtn actionBtn" data-pro-no="${data.row.productNo}">${this.$t('DISPLAY_CATEGORIES_TABLE_HEADER_NINE')}</a>`;
        }
      }
    ]
  };

  public get USMallNos(): Mall[] {
    return this.mallInfo.filter((mall: Mall): any => mall.countryCode === 'US').map((mall): any => mall.mallNo) || [];
  }

  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private mounted() {
    this.getTreeData();
    const $body = $('body');
    $body.on('click', 'button[data-action=addExcel]', $.proxy(this.addExcelClick, this));
    $body.on('click', '.removeBtn', $.proxy(this.deleteProduct, this));
    this.setLeft();
    window.addEventListener('message', this.receiveMessage);
  }
  private beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_SEARCH_' + needToI18nStr));
  }
  private toMall(prevOrNext: string): void {
    if ((this.$refs.theTree as any).hasEditNode) {
      if (confirm(window.$t('CHANGE_MALL_ALERT'))) {
        (this.$refs.theTree as any).hasEditNode = false;
      } else {
        return;
      }
    }
    if (prevOrNext === 'next') {
      if (this.curSelectedIdx === this.mallInfo.length - 1) {
        this.curSelectedIdx = 0;
      } else {
        this.curSelectedIdx = this.curSelectedIdx + 1;
      }
    }
    if (prevOrNext === 'prev') {
      if (this.curSelectedIdx === 0) {
        this.curSelectedIdx = this.mallInfo.length - 1;
      } else {
        this.curSelectedIdx = this.curSelectedIdx - 1;
      }
    }
    this.mallNo = this.mallInfo[this.curSelectedIdx].mallNo;
    this.getTreeData();
  }
  private changeMall(index: number, mallNo: number): void {
    if ((this.$refs.theTree as any).hasEditNode) {
      if (confirm(window.$t('CHANGE_MALL_ALERT'))) {
        this.isCheckedCategoryCode = true;
        this.isChanged = false;
        (this.$refs.theTree as any).hasEditNode = false;
      } else {
        return;
      }
    }
    this.curSelectedIdx = index;
    this.mallNo = mallNo;
    this.getTreeData();
  }
  private getTreeData() {
    const getRequest: GetDisplayCategoriesTreeRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getDisplayCategoriesTree(getRequest).then((res) => {
      if (res && res.data) {
        this.data = res.data;
        this.theData = [];
        this.theData = this.dataFormat(res.data);
        this.childShow = false;
        this.isEmpty = false;
      }
      if (res.data.length === 0) {
        this.theData = [];
        this.childShow = true;
        this.isEmpty = true;
      }
    });
  }
  @Watch('selectParentForm.displayCategoryNo')
  displayCategoryNoChanged() {
    this.isChanged = false;
    this.mallProductNos = [];
    this.exceptedMallProductNos = [];
  }
  @Watch('mallNo', {immediate: false, deep: false})
  async mallNoChanged() {
    this.setLeft();
  }
  private getData(page) {
    this.getProducts(page);
    this.getMappingProducts();
  }
  private curPage: any = 1;
  private curSize: any = 100;
  private getProducts(page?: number, size?: number): void {
    $('#invalidKeyword').remove();
    const obj: GetProductsSearchForDisplayCategoryRequest = {
      params: {
        mallNo: this.mallNo,
        // 'categoryCondition.type': 'DISPLAY',
        // 'categoryCondition.depth': this.selectParentForm.depth,
        displayCategoryNo: this.selectParentForm.displayCategoryNo,
        // 'periodInfo.type': 'REGISTER_DATE',
        // 'periodInfo.period.startYmdt': '2000-01-01 00:00:00',
        // 'periodInfo.period.endYmdt': '2099-12-31 23:59:59',
        page: page ? page : 1,
        size: size ? size : (this.$refs.itemTable as any).itemInfo.pageSize
      }
    };
    if (this.mallProductNos.length) {
      obj.params.productNosBeIncluded = this.mallProductNos.join(',');
    }
    this.exceptedMallProductNos = Array.from(new Set(this.exceptedMallProductNos.map((v) => parseInt(v))));
    if (this.exceptedMallProductNos.length) {
      obj.params.productNosBeExcluded = this.exceptedMallProductNos.join(',');
    }
    this.$api.getProductsSearchForDisplayCategory(obj).then((res) => {
      this.gridData = res.data.contents;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.perPage = obj.params.size;
      this.gridProps.options.pageOptions.page = obj.params.page;
    });
    this.curPage = page ? page : 1;
    this.curSize = size ? size : (this.$refs.itemTable as any).itemInfo.pageSize;
  }
  private mappingMallProductNos: number[] = [];
  private getMappingProducts(mallProductNos?: any) {
    const obj: GetProductsSearchForDisplayCategoryRequest = {
      params: {
        mallNo: this.mallNo,
        displayCategoryNo: this.selectParentForm.displayCategoryNo,
        page: 1,
        size: 2000
      }
    };
    if (mallProductNos) {
      obj.params.productNosBeIncluded = mallProductNos;
    }
    return new Promise<void>((resolve) => {
      this.$api.getProductsSearchForDisplayCategory(obj).then((res) => {
        this.mappingMallProductNos = res.data.contents.map((v) => v.productNo);
        resolve();
      });
    });
  }
  private exceptedMallProductNos: any = [];
  private deleteProduct(e: any) {
    const type = e || '';
    // all
    if (type === 'all') {
      let checkedList = (this.$refs.itemTable as any).getCheckedItems('productNo');
      checkedList = checkedList ? checkedList.split(',') : checkedList;
      this.exceptedMallProductNos = [...this.exceptedMallProductNos, ...checkedList];
      if (checkedList.length == 0) {
        return alert(window.$t('DISPLAY_CATEGORIES_PLEASE_SELECT'));
      }
      if (!window.confirm(window.$t('DISPLAY_CATEGORIES_SURE_DELETE'))) {
        return;
      }
    }
    // one
    else {
      const sure1 = window.$t('DISPLAY_CATEGORIES_SURE1');
      const sure2 = window.$t('DISPLAY_CATEGORIES_SURE2');
      if (!confirm(sure1 + `${$(e.target).data('proNo')}` + sure2)) {
        return;
      }
      this.exceptedMallProductNos.push($(e.target).data('proNo'));
    }
    this.isChanged = true;
    this.getProducts();
  }
  private deletePopShow() {
    (window as any).searchMallProductCallback = this.delMallProductCallback;
    const params = `&callBackName=searchMallProductCallback&limit=500&allBtn=true&btnType=del&categoryCondition.depth=${this.selectParentForm.depth}&categoryCondition.no=${this.selectParentForm.displayCategoryNo}&hideDesc=true&customProperty=true`;
    const url = `/product/search/popup?mallNo=${this.mallNo}${params}`;
    ncpPopup(url, window.$t('EVENT_ADDFORM_PRODUCT__SEARCH'), 1250, 1024);
  }
  private addPopShow() {
    (window as any).searchMallProductCallback = this.searchMallProductCallback;
    const params = '&callBackName=searchMallProductCallback&limit=500&allBtn=true&customProperty=true';
    const url = `/product/search/popup?mallNo=${this.mallNo}${params}`;
    ncpPopup(url, window.$t('EVENT_ADDFORM_PRODUCT__SEARCH'), 1250, 1024);
  }
  private async searchMallProductCallback(mallProducts: any) {
    if (this.isChanged) {
      await this.getMappingProducts(this.mallProductNos.join(','));
    }
    setTimeout((): void => {
      mallProducts = mallProducts.map((item) => {
        Vue.set(item, '_attributes', {checked: false});
        return item;
      });
      const repeatNoList = [];
      const newGridData = [];
      let newMallProducts = [];
      this.mappingMallProductNos.forEach((item) => {
        mallProducts.forEach((v) => {
          if (item == v.mallProductNo) {
            repeatNoList.push(v.mallProductNo);
          }
        });
      });
      if (repeatNoList.length === mallProducts.length) {
        alert(window.$t('DISPLAY_CATEGORIES_NO_REGISTER'));
        return;
      }
      if (repeatNoList.length < mallProducts.length && repeatNoList.length !== 0) {
         const isConfirm = confirm(
          String(this.$t('DISPLAY_CATEGORIES_DISABLE_COUNT', [mallProducts.length,repeatNoList.length,repeatNoList.join(',')]))
          // `입력하신 상품 ${mallProducts.length}개 중 등록 불가능한 상품이 ${repeatNoList.length}개 (${repeatNoList.join(',')}) 있습니다.\n해당 상품을 제외하고 저장하시겠습니까?`
        );
        if (!isConfirm) {
          return;
        }
        newMallProducts = mallProducts.filter((item) => {
          if (!repeatNoList.includes(item.mallProductNo)) {
            return item;
          }
        });
        const productNoItems = newMallProducts.map(v=>v.mallProductNo);
        if(productNoItems && productNoItems.length > 0) {
          productNoItems.forEach(item => {
            this.mallProductNos.push(item);
          });
        }
        // this.mallProductNos = newMallProducts.map(v=>v.mallProductNo);
      }
      if (repeatNoList.length == 0) {
        const productNoItems = mallProducts.map(v=>v.mallProductNo);
        if(productNoItems && productNoItems.length > 0) {
          productNoItems.forEach(item => {
            this.mallProductNos.push(item);
          });
        }
        // this.mallProductNos = mallProducts.map(v=>v.mallProductNo);;
      }
      alert(this.$t('DISPLAY_CATEGORIES_SAVE_BUTTON_FINAL',[mallProducts.length - repeatNoList.length]));
      // alert(`${mallProducts.length - repeatNoList.length}개 상품이 등록되었습니다. 하단 변경사항 저장버튼을 통해 최종으로 저장됩니다.`);
      this.getProducts();
      this.isChanged = true;
    }, 100);
  }
  private delMallProductCallback(mallProducts: any) {
    setTimeout(() => {
      const mallProductsNo = mallProducts.filter((v) => v.displayCategoryNos.length > 1).map((v) => v.mallProductNo);
      alert(`${mallProductsNo.length}` + window.$t('DISPLAY_CATEGORIES_DELETE_OVER_THEN'));
      this.exceptedMallProductNos = [...this.exceptedMallProductNos, ...mallProductsNo];
      this.getProducts();
      this.isChanged = true;
    }, 100);
  }
  private downloadAddedExcel(data) {
    const keyMapJson = {
      mallProductNo: this.getStr('EVENT_ADDFORM_PRODUCT_NO'),
      result: this.$t('DISPLAY_CATEGORIES_REGISTER_RESULT')
    };
    writeExcel(data, keyMapJson, 'Upload_DisplayCategory_ProductNo_' + getDownToday(), {});
  }
  private downloadDataFormat(successList?, failList?) {
    const newSuccessList = [];
    const newFailList = [];
    successList.length &&
      successList.forEach((v) => {
        const obj = {mallProductNo: '', result: ''};
        obj.mallProductNo = v;
        obj.result = String(this.$t('DISPLAY_CATEGORIES_SUCCESS'));
        newSuccessList.push(obj);
      });
    failList.length &&
      failList.forEach((v) => {
        const obj = {mallProductNo: '', result: ''};
        obj.mallProductNo = v;
        obj.result = String(this.$t('DISPLAY_CATEGORIES_FAIL'));
        newFailList.push(obj);
      });
    const data = [...newSuccessList, ...newFailList];
    return data;
  }
  private mallProductNos: any = [];
  private async addProduct(excelList?: any) {
    if (this.isChanged) {
      await this.getMappingProducts(this.mallProductNos.join(','));
    }
    const excelAddList = excelList ? excelList.map(product=>String(product)): undefined;
    const addProductList = this.addProductList
      .replace(/(\n|\r\n)/g, ',')
      .split(',')
      .filter((v: any) => !!v)
    const products = excelAddList ? excelAddList : addProductList
    const obj: any = {
      data: {
        mallNos: [Number(this.mallNo)],
        keywordInfo: {
          type: 'MALL_PRODUCT_NO',
          keywords: products.length ? products : undefined,
        },
        periodInfo: {
          type: 'REGISTER_DATE',
          period: {
            startYmdt: '2000-01-01 00:00:00',
            endYmdt: '2099-12-31 23:59:59',
          }
        },
        //'keywordInfo.type': 'MALL_PRODUCT_NO',
        //'keywordInfo.keywords': excelAddList ? excelAddList : addProductList,
        //'periodInfo.type': 'REGISTER_DATE',
        //'periodInfo.period.startYmdt': '2000-01-01 00:00:00',
        //'periodInfo.period.endYmdt': '2099-12-31 23:59:59',
        page: 1,
        size: 1000
      }
    };
    if (!excelList) {
      if (!this.keywordCheck()) {
        return;
      }
    }
    this.$api.postProductsSearch(obj).then(async (res) => {
      const keywordData = res.data.contents.map((v) => v.mallProductNo);
      const nowProductNos = this.mappingMallProductNos;
      const addProductNos = String(obj.data.keywordInfo.keywords ).split(',').map((v) => Number(v));
      if (!keywordData.length) {
        alert(window.$t('DISPLAY_CATEGORIES_NO_REGISTER'));
        if (excelAddList) {
          this.downloadAddedExcel(this.downloadDataFormat([], addProductNos));
        }
        return;
      }
      const reaptNos = keywordData.filter((v) => {
        if (nowProductNos.includes(v)) {
          return v;
        }
      });
      if (reaptNos.length === keywordData.length) {
        alert(window.$t('DISPLAY_CATEGORIES_NO_REGISTER'));
        if (excelAddList) {
          this.downloadAddedExcel(this.downloadDataFormat([], addProductNos));
        }
        return;
      }
      let addibleNos,
        inexistenceNo = [];
      if (reaptNos.length < keywordData.length && reaptNos.length !== 0) {
        addibleNos = keywordData.filter((item) => {
          if (!reaptNos.includes(item)) {
            return item;
          }
        });
        inexistenceNo = addProductNos.filter((item) => {
          if (!keywordData.includes(item)) {
            return item;
          }
        });
        const isConfirm = confirm(
          // `입력하신 상품 ${addProductNos.length}개 중 등록 불가능한 상품이 ${reaptNos.length + inexistenceNo.length}개 (${reaptNos.join(',')}${
          //   inexistenceNo.length == 0 ? '' : ','
          // }${inexistenceNo.join(',')}) 있습니다.\n해당 상품을 제외하고 저장하시겠습니까?`
          String(this.$t('DISPLAY_CATEGORIES_IN_INPUT_FAIL',[addProductNos.length,reaptNos.length + inexistenceNo.length,reaptNos.join(','),inexistenceNo.length == 0 ? '' : ',',inexistenceNo.join(',')]))
        );
        if (!isConfirm) {
          return;
        }
        const addibleData = keywordData.filter((item) => {
          if (addibleNos.includes(item)) {
            return item;
          }
        });
        if(addibleData && addibleData.length > 0) {
          addibleData.forEach(item=>{
            this.mallProductNos.push(item);
          });
        }
        // this.mallProductNos = addibleData;
        alert(this.$t('DISPLAY_CATEGORIES_SAVE_BUTTON_FINAL',[addibleData.length]));
        // alert(`${this.mallProductNos.length}개 상품이 등록되었습니다. 하단 변경사항 저장버튼을 통해 최종으로 저장됩니다.`);
        if (excelAddList) {
          this.downloadAddedExcel(this.downloadDataFormat(addibleData, [...reaptNos, ...inexistenceNo]));
        }
      }
      if (reaptNos.length === 0) {
        inexistenceNo = addProductNos.filter((item) => {
          if (!keywordData.includes(item)) {
            return item;
          }
        });
        const addibleData = keywordData.filter((item) => {
          if (!reaptNos.includes(item)) {
            return item;
          }
        });
        if (inexistenceNo.length) {
          if (!confirm(String(this.$t('DISPLAY_CATEGORIES_DISABLE_COUNT',[addProductNos.length,inexistenceNo.length,inexistenceNo.join(',')])))) {
          // if (!confirm(`입력하신 상품 ${addProductNos.length}개 중 등록 불가능한 상품이 ${inexistenceNo.length}개 (${inexistenceNo.join(',')}) 있습니다.\n해당 상품을 제외하고 저장하시겠습니까?`)) {
            return;
          }
        }
        if(addibleData && addibleData.length > 0) {
          addibleData.forEach(item=>{
            this.mallProductNos.push(item);
          });
        }
        // this.mallProductNos = addibleData;
        alert(this.$t('DISPLAY_CATEGORIES_SAVE_BUTTON_FINAL',[addibleData.length]));
        // alert(`${this.mallProductNos.length}개 상품이 등록되었습니다. 하단 변경사항 저장버튼을 통해 최종으로 저장됩니다.`);

        if (excelAddList) {
          this.downloadAddedExcel(this.downloadDataFormat(addibleData, inexistenceNo));
        }
      }
      this.getProducts();
      this.isChanged = true;
    });
  }
  private keywordCheck() {
    const value = ($('#keyword').val() as any).replace(/(?:\\[rn]|[\r\n]+)+/g, ',');
    const $parentWrap = $('#keyword').parents('.inputbox_wrap');
    const regex = /^[0-9,]+$/;
    $parentWrap.find('#invalidKeyword').remove();
    if (!regex.test(value)) {
      if ($parentWrap.find('#invalidKeyword').length == 0) {
        $('#keyword').addClass('validation_fail_target');
        $parentWrap.append(`<div id="invalidKeyword" class="form_guide_pass full" style="margin-left:110px">${window.$t('EVENT_ADDFORM_ONLY_NUMBER_COMA')}</div>`);
      }
      return false;
    }
    if (value.split(',').filter((v: any) => v.length > 10).length) {
      $('#keyword').addClass('validation_fail_target');
      $parentWrap.append(`<div id="invalidKeyword" class="form_guide_pass full" style="margin-left:110px">${window.$t('EVENT_ADDFORM_PRODUCTNO_ONLY_UNDER_TEN')}</div>`);
      return false;
    }
    $parentWrap.find('#invalidKeyword').remove();
    $('#keyword').removeClass('validation_fail_target');
    return true;
  }

  private getStr(str: string): string {
    return '' + this.$t(str);
  }
  private addExcelClick(e: any) {
    $(e.target).siblings('input[data-action=excelFile]').click();
  }
  private addExcelChange(e: any) {
    const file = $(e.target)[0].files[0];
    const keyMapJson = {
      mallProductNo: this.getStr('EVENT_ADDFORM_PRODUCT_NO')
    };
    readExcelFile(file, keyMapJson, (data) => {
      const addNoList = data.map((v) => v.mallProductNo);
      const newAddList = [];
      const regex = /^[0-9]+$/;
      addNoList.forEach((v) => {
        if (!regex.test(v)) {
          newAddList.push(0);
        } else {
          newAddList.push(v);
        }
      });
      this.addProduct(newAddList);
    });
    $('input[data-action=excelFile]').val('');
  }
  private onClickExcelDownStyle() {
    getStorageByName('Upload_DisplayCategory_ProductNo_Sample.xlsx');
  }

  private tuiTreeSelect(template: any): void {
    this.selectNum = template.theIndex;
    this.selectParentForm = template.theObj;
    this.strLength = this.selectParentForm.displayCategoryName.length;
    this.codeLength = this.selectParentForm.displayCategoryManagementCode.length;
    this.wrapShow = template.theObj.topImageContent ? true : false;
    if (template.theObj.isNew) {
      this.isFile = false;
    } else {
      this.isFile = template.theObj.isParent ? false : true;
    }
    const $imageArea = $('input[name=categoryIcon]').parents('.image_area');
    if (this.uploadFileNos.length > 0) {
      this.uploadFileNos.forEach((v) => {
        const noList = this.uploadFileNos.map((v) => v.no);
        if (!noList.includes(template.theObj.displayCategoryNo)) {
          if (template.theObj.icon) {
            this.setPreviewImage($imageArea, template.theObj.icon);
            $('input[name=categoryIcon]').data('url', template.theObj.icon);
          } else {
            $imageArea.find('.preview').hide();
            $imageArea.find('.remove').hide();
          }
        } else {
          const url = this.uploadFileNos.find((v) => v.no == template.theObj.displayCategoryNo).url;
          this.setPreviewImage($imageArea, url);
          $('input[name=categoryIcon]').data('url', url);
        }
      });
    } else {
      if (template.theObj.icon) {
        this.setPreviewImage($imageArea, template.theObj.icon);
        $('input[name=categoryIcon]').data('url', template.theObj.icon);
      } else {
        $imageArea.find('.preview').hide();
        $imageArea.find('.remove').hide();
      }
    }
    if(!this.isFile) {
      this.classChange('configMenu');
    }
    if (this.type === 'productMenu') {
      this.getProducts();
    }
  }
  private addGroupTree(): any {
    (this.$refs.theTree as any).addTree();
    this.type = 'configMenu';
    this.isEmpty = false;
    this.childShow = false;
  }
  private onClickRemoveBtn() {
    const tree = (this.$refs.theTree as any).tree;
    const selectedNodeId = tree.getSelectedNodeId();
    const isGroup = tree.getDepth(selectedNodeId) === 1;

    if (isGroup) {
      let msg;
      if (tree.getChildIds(selectedNodeId).length !== 0) {
        msg = 'DISPLAY_CATEGORIES_CONFIRM_DELETE_GROUP_TEMPLATE';
      } else {
        msg = 'DISPLAY_CATEGORIES_CONFIRM_DELETE_GROUP';
      }

      if (confirm(this.$t(msg) as string)) {
        if (Array.isArray(selectedNodeId)) {
          tree.remove(selectedNodeId[0]);
        } else {
          tree.remove(selectedNodeId);
        }
        tree.select(tree.model.rootNode._childIds[0]);
        if (tree.model.rootNode._childIds.length === 0) {
          this.theData = [];
        }
      }
    } else {
      const msg = 'DISPLAY_CATEGORIES_CONFIRM_DELETE_TEMPLATE';

      if (confirm(this.$t(msg) as string)) {
        const templateNo = tree.getNodeData(selectedNodeId).templateNo;

        if (templateNo > 0) {
          // let obj = {
          //   pathParams: {
          //     groupNo: this.selectChildForm.parentData.groupNo + '',
          //     templateNo: templateNo + ''
          //   },
          //   params: {
          //     mallNo: mallNo
          //   }
          // };
          // this.$api.deleteMailTemplatesCustomGroupsTemplates(obj).then(() => {
          //   if (Array.isArray(selectedNodeId)) {
          //     tree.remove(selectedNodeId[0]);
          //   } else {
          //     tree.remove(selectedNodeId);
          //   }
          //   tree.select(tree.model.rootNode._childIds[0]);
          //   if (tree.model.rootNode._childIds.length === 0) {
          //     this.theData = [];
          //   }
          // });
        } else {
          if (Array.isArray(selectedNodeId)) {
            tree.remove(selectedNodeId[0]);
          } else {
            tree.remove(selectedNodeId);
          }
          tree.select(tree.model.rootNode._childIds[0]);
          if (tree.model.rootNode._childIds.length === 0) {
            this.theData = [];
          }
        }
      }
    }
  }
  private dataFormat(data: any[]): any[] {
    const newData = data.map((item) => {
      Vue.set(item, 'displayCategoryManagementCode', item.displayCategoryManagementCode || '');
      Vue.set(item, 'text', item.displayCategoryName);
      Vue.set(item, 'state', 'closed');
      if(item.displayYn && item.displayYn === 'Y') {
        Vue.set(item, 'displayIcon', '');
      } else {
        Vue.set(item, 'displayIcon', '<span class="ico_noshow"></span>');
      }
      if (item.children) {
        Vue.set(item, 'children', item.children);
        if (item.children.length > 0) {
          Vue.set(item, 'isParent', true);
          this.dataFormat(item.children);
        }
      }
      return item;
    });
    return newData;
  }
  private productExcelDown() {
    const excelDownInfo = {
      fileName: 'display_category_products_',
      columns: {},
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    };
    const excelColumn: any = {};
    this.excel.columns.forEach((column: any): void => {
      excelColumn[column.name] = column.header;
    });
    excelDownInfo.columns = excelColumn;
    const model = gridModelToExcel(this.excel.columns);
    excelDownInfo.formatters = model.formatter;
    const obj: ProductsSearchRequest = {
      params: {
        mallNos: this.mallNo + '',
        'keywordInfo.type': 'MALL_PRODUCT_NO',
        'categoryCondition.type': 'DISPLAY',
        'categoryCondition.depth': this.selectParentForm.depth,
        'categoryCondition.no': this.selectParentForm.displayCategoryNo,
        'periodInfo.type': 'REGISTER_DATE',
        'periodInfo.period.startYmdt': '2000-01-01 00:00:00',
        'periodInfo.period.endYmdt': '2099-12-31 23:59:59',
        page: this.curPage,
        size: this.curSize
      }
    };

    this.$api.getProductsExcelSearch(obj).then((res) => {
      if (this.data && this.data.length > 0) {
        const columns = i18nAllObject(this, excelDownInfo.columns);
        let fileName = excelDownInfo.fileName;
        if (excelDownInfo.nameDateFormat !== undefined) {
          fileName += changeDateFormat(new Date(), excelDownInfo.nameDateFormat);
        }

        writeExcel(res.data, columns, fileName, excelDownInfo.formatters);
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    });
  }
  private excelDown() {
    const getRequest: GetDisplayCategoriesExcelRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getDisplayCategoriesExcel(getRequest).then((res) => {
      if (res && res.data) {
        const excelDownInfo = {
          fileName: 'display_category_',
          columns: {
            depth1DisplayCategoryNo: 'DISPLAY_CATEGORIES_CATEGORY_NO',
            depth1DisplayCategoryManagementCode: 'DISPLAY_CATEGORIES_DISPLAY_CATEGORY_CODE',
            depth1DisplayCategoryName: 'DISPLAY_CATEGORIES_CATEGORY_DEPTH1',
            depth2DisplayCategoryNo: 'DISPLAY_CATEGORIES_CATEGORY_NO',
            depth2DisplayCategoryManagementCode: 'DISPLAY_CATEGORIES_DISPLAY_CATEGORY_CODE',
            depth2DisplayCategoryName: 'DISPLAY_CATEGORIES_CATEGORY_DEPTH2',
            depth3DisplayCategoryNo: 'DISPLAY_CATEGORIES_CATEGORY_NO',
            depth3DisplayCategoryManagementCode: 'DISPLAY_CATEGORIES_DISPLAY_CATEGORY_CODE',
            depth3DisplayCategoryName: 'DISPLAY_CATEGORIES_CATEGORY_DEPTH3',
            depth4DisplayCategoryNo: 'DISPLAY_CATEGORIES_CATEGORY_NO',
            depth4DisplayCategoryManagementCode: 'DISPLAY_CATEGORIES_DISPLAY_CATEGORY_CODE',
            depth4DisplayCategoryName: 'DISPLAY_CATEGORIES_CATEGORY_DEPTH4',
            depth5DisplayCategoryNo: 'DISPLAY_CATEGORIES_CATEGORY_NO',
            depth5DisplayCategoryManagementCode: 'DISPLAY_CATEGORIES_DISPLAY_CATEGORY_CODE',
            depth5DisplayCategoryName: 'DISPLAY_CATEGORIES_CATEGORY_DEPTH5'
          }
        };
        const columns = i18nAllObject(this, excelDownInfo.columns);
        writeExcel(res.data, columns, excelDownInfo.fileName + '_' + getDownToday(), null);
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    });
  }
  private receiveMessage(e: MessageEvent) {
    if (e.data === 'SUCCESS') {
      this.getTreeData();
    }
  }

  private openExcelUploadPopup(title:string) {
    title = this.$t(title).toString();
    ncpPopup(`/popup/display-category-excel-batch-register?mallNo=${this.mallNo}`, title, 900, 560);
  }

  private show(ev: any) {
    (this.$refs.theTree as any).onKeyupCategoryName(ev);
  }
  private show1() {
    this.strLength = this.selectParentForm.displayCategoryName.length;
  }
  private changeCategoryManagementCode(e: Event) {
    const regex = new RegExp(/[\\\*\?\"\<\>]+/, 'g')
    const target = e.target as HTMLInputElement;

    if ((e.target as HTMLInputElement).value.match(regex)) {
      alert('\, *, ?, ”, <, > 은(는) 입력할 수 없습니다.');
      target.value = target.value.replace(regex, '');
    }
    const tree = this.$refs.theTree as any;
    tree.setSelectedNodeData('displayCategoryManagementCode', target.value, false);
    this.selectParentForm.displayCategoryManagementCode = target.value;
    this.codeLength = target.value.length;
    this.isCheckedCategoryCode = !target.value;
    (this.$refs.theTree as any).hasEditNode = true;
  }
  private async checkDuplicate() {
    if (!this.selectParentForm.displayCategoryManagementCode) {
      alert('카테고리 코드를 입력해주세요.');

      return;
    }

    this.$api.getDisplayCategoriesDuplicateManagementCode({ params: { mallNo: this.mallNo, managementCode: this.selectParentForm.displayCategoryManagementCode }})
      .then((res) => {
        if (res.data) {
          alert('카테고리 코드가 이미 사용중입니다.');
          return;
        }
        alert('사용 가능한 카테고리 코드입니다.')
        this.isCheckedCategoryCode = true;
      });
  }
  private validate() {
    if (!this.selectParentForm.displayCategoryManagementCode) {
      return true;
    }

    if (!this.isCheckedCategoryCode) {
      alert('카테고리 코드 중복확인을 진행해주세요.');
      
      return false;
    }

    return true;
  }
  private updateStrLen(displayCategoryNameValue: string) {
    this.selectParentForm.displayCategoryName = displayCategoryNameValue;
    if(!this.selectParentForm.displayCategoryName || this.selectParentForm.displayCategoryName.length === 0) {
      this.strLength = 0;
    } else {
      this.strLength = this.selectParentForm.displayCategoryName.length;
    }
  }
  private displayYn2(ev: any) {
    (this.$refs.theTree as any).onChangeDisplayYn(ev);
  }
  private topImageUseYn(ev: any) {
    if (ev.target.value == 'Y') {
      this.wrapShow = true;
    }
  }
  private topImageUseYn2(ev: any) {
    if (ev.target.value == 'N') {
      this.wrapShow = false;
    }
  }
  private classChange(data: string) {
    this.type = data;
  }
  private setTopImageContent() {
    var isChecked = $('input:radio[name="topImageUseYn"]:checked').val();
    if (isChecked === 'N') {
      this.selectParentForm.topImageContent = '';
    } else {
      this.selectParentForm.topImageContent = this.editorContent;
    }
    const tree = this.$refs.theTree as any;
    tree.setSelectedNodeData('topImageContent', this.selectParentForm.topImageContent, false);
  }
  private setIcon() {
    let articleImageUrl;
    if (!this.isCategoryIconRemoved) {
      articleImageUrl = $('input[name=categoryIcon]').data('url');
    } else {
      articleImageUrl = '';
    }
    this.selectParentForm.icon = articleImageUrl;
    const tree = this.$refs.theTree as any;
    tree.setSelectedNodeData('icon', this.selectParentForm.icon, false);
  }
  private onClickFindImageBtn(e: any) {
    var $imageArea = $(e.target).parents('.image_area');
    $imageArea.find('[type=file]').trigger('click');
    $imageArea.find('input[type=file]').val('');
  }
  private beforeUpload(file: any) {
    if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/)) {
      alert(window.$t('DISPLAY_CATEGORIES_ONLY_IMAGE'));
      return false;
    }
    if (file.size / 1024 > 512) {
      alert(window.$t('DISPLAY_CATEGORIES_MAX_512'));
      return false;
    }
    return true;
  }
  private onChangeCategoryIconFile(event: any) {
    const $imageArea = $(event.target).parents('.image_area');
    const {files} = event.target;
    if (!this.beforeUpload(files[0])) {
      return;
    }
    const mallNo = this.mallNo;
    uploadFile(files, mallNo as any).then((responses: any) => {
      const data = responses.map((res: any): {} => {
        return {url: res.data.url};
      });
      $(event.target).data('url', data[0].url);
      const obj = {
        no: this.selectParentForm.displayCategoryNo,
        url: data[0].url
      };
      this.uploadFileNos.push(obj);
      this.setPreviewImage($imageArea, data[0].url);
    });
    this.isCategoryIconRemoved = false;
  }
  private setPreviewImage($imageArea: any, url: any) {
    $imageArea.find('.preview').empty().append(`<img src="${url}" style="width:100%;" />`).show();
    $imageArea.find('.remove').show();
  }
  private onClickRemoveImageBtn(e: any) {
    this.uploadFileNos = this.uploadFileNos.filter((v) => v.no !== this.selectParentForm.displayCategoryNo);
    const $imageArea = $(e.target).parents('.image_area');
    const $mainImage = $(e.target).siblings('input[type=file]');

    $mainImage.data('url', '').data('image_no', '');
    $mainImage.val('');
    $imageArea.find('.preview').html('');
    $imageArea.find('.preview').css('display', '');
    $imageArea.find('.remove').hide();
    this.isCategoryIconRemoved = true;
  }
  private getChildrenNodeData(parentNodeId: any) {
    const datas = [];
    const tree = (this.$refs.theTree as any).tree;
    const childIds = tree.getChildIds(parentNodeId);

    for (const nodeId of childIds) {
      const data = tree.getNodeData(nodeId);
      data.depth = tree.getDepth(nodeId);
      data.mallNo = $('#mallNo').val();
      data.displayCategoryName = data.text;
      data.displayOrder = datas.length + 1;
      data.displayYn = data.displayYn;
      data.parentDisplayCategoryNo = tree.getNodeData(parentNodeId).displayCategoryNo ? tree.getNodeData(parentNodeId).displayCategoryNo : 0;
      data.children = this.getChildrenNodeData(nodeId);
      data.icon = data.icon === '' ? null : data.icon;
      datas.push(data);
    }

    return datas;
  }
  private saveCategories(data: any) {
    if (!this.validate()) {
      return;
    }

    const request: PutDisplayCategoriesSyncRequest = {
      params: {
        mallNo: this.mallNo
      },
      data: {
        displayCategoryTrees: data
      }
    };
    this.$api.putDisplayCategoriesSync(request).then(() => {
      alert(window.$t('DISPLAY_CATEGORIES_SAVE_OVER'));
      this.getTreeData();
      this.isCheckedCategoryCode = true;
      this.isChanged = false;
      (this.$refs.theTree as any).hasEditNode = false;
    });
  }
  private productsSave() {
    if (this.exceptedMallProductNos.length == 0 && this.mallProductNos.length == 0) {
      return alert(window.$t('DISPLAY_CATEGORIES_NO_CHANGE'));
    }
    const request: PutProductsCategoryMappingsRequest = {
      data: {
        removedProductNos: this.exceptedMallProductNos,
        addedProductNos: this.mallProductNos,
        displayCategoryNo: this.selectParentForm.displayCategoryNo
      }
    };
    this.$api.putProductsCategoryMappings(request).then(() => {
      alert(window.$t('DISPLAY_CATEGORIES_SAVE_OVER_2'));
      this.isChanged = false;
    });
  }
  private save() {
    this.setTopImageContent();
    this.setIcon();
    const tree = (this.$refs.theTree as any).tree;
    const data = this.getChildrenNodeData(tree.getRootNodeId());
    this.saveCategories(data);
  }
  private editorOnChange({html, text}: {html: string; text: string}): void {
    this.editorContent = html;
  }
  private get countChange() {
     if (Number(this.strLength) === 0) {
      return '';
    } else if (Number(this.strLength) === 50) {
      return 'max';
    } else {
      return 'counting';
    }
  }
  private get codeCountChange() {
     if (Number(this.codeLength) === 0) {
      return '';
    } else if (Number(this.codeLength) === 45) {
      return 'max';
    } else {
      return 'counting';
    }
  }
  private setLeft() {
    const listWidth = $('#mall_list_div').width();

    const tempWidth = (this.curSelectedIdx + 2) * 112;
    if (listWidth - tempWidth < 0) {
      this.styleLeft = listWidth - tempWidth;
    } else {
      this.styleLeft = 0;
    }
  }
   private get showTab() {
    let flg = false;
    if (this.malls && this.malls.length && this.malls.length > 1) {
      flg = true;
    }
    return flg;
  }
}
